// extracted by mini-css-extract-plugin
module.exports = {"fare":"fare_fare_3Db5v","liststyle":"fare_liststyle_kb_yP","liststyle2":"fare_liststyle2_2k1SC"};